import axios from 'axios'
import { BigOrder,
  BigOrderItem,
  GetOneOrderResponse,
  Order,
  OrderPurchasesCertificate,
  GetOneOrderAllOrderItemsResponse
} from 'src/core/models'

export async function getMyOrdersListAPI(total: number = 4, currency_code: string = null): Promise<BigOrder[]> {
  const mainUrl = `/api/v1/orders/get/?total=${total}`
  const url = currency_code ? `${mainUrl}&currency_code=${currency_code}` : mainUrl
  const { data } = await axios.get<BigOrder[]>(url)
  return data
}

export async function getPurchasesFromCertificatesAPI(certificates: string[]): Promise<OrderPurchasesCertificate[]> {
  const url = '/api/v1/orders/get_purchases_from_certificates/'
  const { data } = await axios.post<OrderPurchasesCertificate[]>(url, certificates)
  return data
}

export async function getOneOrderAPI(
  orderId: number,
  orderItemId: number,
  currency_code: string): Promise<GetOneOrderResponse> {
  const mainUrl = `/api/v1/orders/get_one/?id=${orderId}`
  const url = currency_code ? `${mainUrl}&currency_code=${currency_code}` : mainUrl
  const { data } = await axios.get<{ order: Order, order_items: BigOrderItem[]}>(url)
  return { order: data.order, orderItem: data.order_items.find(x => x.id === orderItemId) }
}
export async function getOneOrderAllOrderItemsAPI(
  orderId: number, currency_code: string): Promise<GetOneOrderAllOrderItemsResponse> {
  const mainUrl = `/api/v1/orders/get_one/?id=${orderId}`
  const url = currency_code ? `${mainUrl}&currency_code=${currency_code}` : mainUrl
  const { data } = await axios.get<{ order: Order, order_items: BigOrderItem[]}>(url)
  return { order: data.order, orderItems: data.order_items }
}
